/**
 * Responsive 16:9 video embed.
 *
 * The iframe fills an aspect-ratio box so the frame keeps its shape before the
 * player loads and never causes layout shift.
 *
 * @param {string} src    player embed URL
 * @param {string} title  accessible name for the iframe
 */
export default function VideoEmbed({ src, title }) {
  return (
    <div className="video-frame">
      <iframe
        src={src}
        title={title}
        loading="lazy"
        referrerPolicy="origin"
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen; clipboard-write"
        allowFullScreen
      />
    </div>
  );
}
